module.exports = __webpack_public_path__ + "img/ico-marker-shadow.2bd603d4.svg";